import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import SweetAlert from "sweetalert2-react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import fire from "../config/Fire";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class EditarPost extends React.Component {
  constructor(props) {
    super(props);
    this.titulo = props.titulo;
    this.contenido = props.contenido;
    this.tipo = props.tipo;
    this.handleUploadAR = this.handleUploadAR.bind(this);
    this.cambiosInputs = this.cambiosInputs.bind(this);
  }
  //Permite obtener la información del post
  componentDidMount() {
    this.setState({
      titulo: this.titulo,
      contenido: this.contenido
    });
    if (this.tipo === "video") {
      this.setState({
        tipotitulo: "Video"
      });
    } else {
      this.setState({
        tipotitulo: "Imagen"
      });
    }
  }
  state = {
    open: false,
    value: null,
    disabled: true,
    disabledu: true,
    link: "",
    contenido: "",
    titulo: "",
    imagen: null,
    uploadValue: 0,
    direccion: null,
    titulo1: ""
  };
  //Permite abrir el dialogo
  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };
  //Permite cerrar el dialogo
  handleClose = () => {
    this.setState({
      open: false,
      value: null,
      disabled: true,
      disabledu: true,
      link: "",
      imagen: null,
      uploadValue: 0,
      direccion: null
    });
    this.setState({
      show: true,
      estado: "error",
      texto: "El post no ha sido editado",
      titulo1: "Error"
    });
  };
  //Permite saber si es imágen o video la que tendrá el post
  handleChange = event => {
    this.setState({ value: event.target.value });
    if (event.target.value === "imagen") {
      this.setState({ disabled: true, disabledu: false });
    } else if (event.target.value === "video") {
      this.setState({ disabled: false, disabledu: true });
    } else {
      this.setState({ disabled: true, disabledu: true });
    }
  };
  //Guarda lo que escribe el usuario en los inputs
  cambiosInputs(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Crea el post
  subirPost = () => {
    if (this.state.value === "imagen") {
      if (this.state.uploadValue === 100) {
        fire
          .database()
          .ref()
          .child("Posts")
          .orderByChild("titulo")
          .equalTo(this.titulo)
          .on("child_added", snapshot => {
            fire
              .database()
              .ref()
              .child("Posts")
              .child(snapshot.key)
              .update({
                contenido: this.state.contenido,
                link: this.state.direccion,
                nombreimg: this.state.imagen.name
              });
            window.location.reload();
          });
      } else {
        this.setTimeout();
      }
    } else {
      fire
        .database()
        .ref()
        .child("Posts")
        .orderByChild("titulo")
        .equalTo(this.titulo)
        .on("child_added", snapshot => {
          fire
            .database()
            .ref()
            .child("Posts")
            .child(snapshot.key)
            .update({
              contenido: this.state.contenido,
              link: this.state.link
            });
          window.location.reload();
        });
    }
  };
  //Muestra el dialogo si se editó satisfactoriamente
  satisfactorio = () => {
    this.setState({
      open: false,
      value: null,
      disabled: true,
      disabledu: true,
      link: "",
      imagen: null,
      uploadValue: 0,
      direccion: null
    });
    this.setState({
      show: true,
      estado: "success",
      texto: "El post ha sido editado",
      titulo1: "¡Enhorabuena!"
    });
  };
  setTimeout = () => {
    setTimeout(this.subirPost, 2000);
  };
  //Para saber que tipo de post es
  handleNew = () => {
    if (this.state.value !== null && this.state.value !== "no") {
      if (this.state.value === "imagen") {
        if (this.state.imagen !== null) {
          this.subirImagen();
          this.subirPost();
        } else alert("Debes ingresar la nueva imagen del post");
      } else {
        if (this.state.link !== "") {
          this.subirPost();
        } else alert("Debes ingresar el nuevo link del post");
      }
    } else {
      this.actualizarTextos();
    }
  };
  actualizarTextos() {
    fire
      .database()
      .ref()
      .child("Posts")
      .orderByChild("titulo")
      .equalTo(this.titulo)
      .on("child_added", snapshot => {
        fire
          .database()
          .ref()
          .child("Posts")
          .child(snapshot.key)
          .update({
            contenido: this.state.contenido
          });
        window.location.reload();
      });
  }

  //Sube la imagen a firebase
  subirImagen() {
    this.setState({ show: false });

    this.setState({ nombreimg: null });

    fire.auth().onAuthStateChanged(user => {
      fire
        .database()
        .ref()
        .child("Posts")
        .orderByChild("titulo")
        .equalTo(this.titulo)
        .on("child_added", snapshot => {
          this.setState({ nombreimg: snapshot.val().nombreimg });
        });
      if (user) {
        const storageRefImg = fire
          .storage()
          .ref(`/Posts/${this.titulo}/${this.state.nombreimg}`);
        storageRefImg
          .delete()
          .then(function() {})
          .catch(function(error) {
            console.log(error);
          });
        const storageRef = fire
          .storage()
          .ref(`/Posts/${this.state.titulo}/${this.state.imagen.name}`);
        const task = storageRef.put(this.state.imagen);
        task.on(
          "state_changed",
          snapshot => {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({
              uploadValue: percentage
            });
          },
          error => {},
          () => {
            storageRef.getDownloadURL().then(url => {
              this.setState({
                direccion: url
              });
            });
          }
        );
      }
    });
  }

  //Guarda información de la imagen
  handleUploadAR(event) {
    const file = event.target.files[0];
    this.setState({ imagen: file });
  }
  //Renderiza la interfaz del diálogo
  render() {
    return (
      <div>
        <div>
          <Button color="primary" onClick={this.handleClickOpen}>
            EDITAR
          </Button>
          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Editar post: " + this.titulo}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="outlined-full-width"
                label="Detalle"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="contenido"
                onChange={this.cambiosInputs}
                value={this.state.contenido}
              />
              <FormControl component="fieldset">
                <FormLabel component="legend">Contenido</FormLabel>
                <RadioGroup
                  aria-label="Gender"
                  name="gender1"
                  value={this.state.value}
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    value={this.tipo}
                    control={<Radio />}
                    label={this.state.tipotitulo}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Sin cambios"
                  />
                </RadioGroup>
              </FormControl>

              <TextField
                disabled={this.state.disabled}
                id="outlined-full-width"
                label="Link"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="link"
                onChange={this.cambiosInputs}
                value={this.state.link}
              />
              <div>
                <br />
                <input
                  accept="image/*"
                  type="file"
                  disableUnderline={true}
                  disabled={this.state.disabledu}
                  name="Imagen"
                  onChange={this.handleUploadAR}
                />
                <br />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleNew} color="primary">
                Editar post
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <SweetAlert
            show={this.state.show}
            title={this.state.titulo1}
            type={this.state.estado}
            text={this.state.texto}
            onConfirm={() => this.setState({ show: false })}
          />
        </div>
      </div>
    );
  }
}

export default EditarPost;
